import React from 'react';
import { List, ListItemButton, ListItemAvatar, ListItemText } from '@mui/material';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

const NewsList = ({ pages }) => {
  return (
    <List>
      {pages &&
        pages.map((page) => (
          <ListItemButton button component="a" href={page.pageUrl} target="_blank">
            <ListItemAvatar>
              <ReceiptOutlinedIcon />
            </ListItemAvatar>
            <ListItemText primary={page.title} />
          </ListItemButton>
        ))}
    </List>
  );
};

export default NewsList;
